module.exports = __webpack_public_path__ + "static/media/footer-bg-img.60e52163.jpg";